export interface DateTimeService {
    isUTCDate(date: string | Date): boolean;
    isDate(date: string | Date): boolean;
    milisecondsFromZulu(date: string): number;
    getDateWithoutTimezone(date: Date): Date;
    getDateWithTimezone(date: Date): Date;
}

export const dateTimeService = (): DateTimeService => {
    const isUTCDate = (date: string | Date): boolean => {
        const regex = RegExp(
            /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])?(Z)?/g
        );

        return typeof date === "string" ? regex.test(date) : false;
    };

    const isDate = (date: string | Date): boolean => {
        return !Number.isNaN(new Date(date).getTime());
    };

    const milisecondsFromZulu = (date: string): number => {
        return new Date(date).getTime();
    };

    const getDateWithoutTimezone = (date: Date): Date => {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    };

    const getDateWithTimezone = (date: Date): Date => {
        return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    };

    return {
        isUTCDate,
        isDate,
        milisecondsFromZulu,
        getDateWithoutTimezone,
        getDateWithTimezone
    };
};
